// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"a1f714cb","118":"8fd58ff8","264":"253e6f90","312":"acd874f9","453":"df782fef","531":"ec0e7045","569":"67026984","903":"125fff59","910":"a9656b64","919":"e808d307","924":"e0d7590d"}[chunkId] + ".chunk.js";
};